import React from 'react';

const BreadAccessManagement = () => {
  return (
    <div className="container-fluid p-4">
      <div className="row">
        <div className="col-12">
          <h1 className="mb-4">Bread Access Management</h1>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Access Control & Permissions</h5>
              <p className="card-text">
                Manage user access, roles, and permissions for Bread department resources.
              </p>
              <div className="row mt-4">
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <h6>User Access Overview</h6>
                    </div>
                    <div className="card-body">
                      <div className="d-flex justify-content-between mb-2">
                        <span>Active Users:</span>
                        <span className="badge bg-primary">67</span>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span>Admin Users:</span>
                        <span className="badge bg-danger">5</span>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span>Read-Only Users:</span>
                        <span className="badge bg-info">42</span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>Pending Approvals:</span>
                        <span className="badge bg-warning">3</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <h6>Permission Groups</h6>
                    </div>
                    <div className="card-body">
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item d-flex justify-content-between">
                          Production Staff
                          <span className="badge bg-success">23 users</span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between">
                          Quality Control
                          <span className="badge bg-info">12 users</span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between">
                          Management
                          <span className="badge bg-warning">8 users</span>
                        </li>
                        <li className="list-group-item d-flex justify-content-between">
                          Auditors
                          <span className="badge bg-secondary">4 users</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreadAccessManagement;